import React from 'react'

import { Zoom, ZoomTypes, ZoomProps } from 'components/Zoom'

import DocumentNavbar from '../DocumentNavbar'
import PlayPrototypeLink from '../PlayPrototypeLink'
import { IS_EMBEDDED } from '@sketch/constants'

import { Wrapper, TextToolbar as Text } from './DocumentMobileToolbar.styles'
import { AddAnnotationNavbarItem } from 'modules/annotations/components'
import { DocumentActions } from 'modules/shares/PageCanvasView/components/PageCanvasViewHeader/DocumentActions'

type ToolboxItem = 'search' | 'zoom' | 'prototype' | 'add-annotation'

const TOOLBOX_ITEMS = ['search', 'zoom', 'prototype', 'add-annotation']
const DRAFT_ANNOTATION_HEADER_ARTBOARD = {
  true: 'Tap on the Artboard to comment',
  false: 'Tap anywhere to comment',
}

interface DocumentMobileToolboxProps {
  items: ToolboxItem[]
  zoom?: ZoomTypes
  setZoom?: ZoomProps['onZoomChanged']
  shareIdentifier?: string
  permanentArtboardShortId?: string
  isPrototypePlayEnabled?: boolean
  isDraftAnnotationEnabled?: boolean
  setPlaceDraftAnnotation?: (state: boolean) => void
  disableAddAnnotationButton?: boolean
}

export const isMobileToolboxItem = (item: any): item is ToolboxItem => {
  return TOOLBOX_ITEMS.includes(item)
}

const DocumentMobileToolbox = (props: DocumentMobileToolboxProps) => {
  const {
    items,
    zoom,
    setZoom,
    shareIdentifier,
    permanentArtboardShortId,
    isPrototypePlayEnabled,
    isDraftAnnotationEnabled,
    disableAddAnnotationButton,
  } = props

  const showSearch = items.includes('search') && !IS_EMBEDDED
  const showZoom = items.includes('zoom')
  const showPrototype = items.includes('prototype')
  const showAddAnnotation = items.includes('add-annotation')

  if (isDraftAnnotationEnabled) {
    const title =
      DRAFT_ANNOTATION_HEADER_ARTBOARD[
        `${Boolean(permanentArtboardShortId)}` as const
      ]

    return (
      <Wrapper>
        <Text>{title}</Text>
        {showZoom && zoom && setZoom && <Zoom zoom={zoom} setZoom={setZoom} />}
        <AddAnnotationNavbarItem disabled={disableAddAnnotationButton} />
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      {showPrototype && shareIdentifier && permanentArtboardShortId && (
        <PlayPrototypeLink
          shareIdentifier={shareIdentifier}
          isPrototypePlayEnabled={!!isPrototypePlayEnabled}
          permanentArtboardShortId={permanentArtboardShortId}
          representation="toolbar"
        />
      )}
      {showSearch && <DocumentNavbar />}
      {showZoom && zoom && setZoom && <Zoom zoom={zoom} setZoom={setZoom} />}
      <DocumentActions />
      {showAddAnnotation && (
        <AddAnnotationNavbarItem disabled={disableAddAnnotationButton} />
      )}
    </Wrapper>
  )
}

export default DocumentMobileToolbox
